"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSameChain = void 0;
const tslib_1 = require("tslib");
const BtcChains_1 = tslib_1.__importDefault(require("./btc/BtcChains"));
const EvmChains_1 = tslib_1.__importDefault(require("./evm/EvmChains"));
const NearChains_1 = tslib_1.__importDefault(require("./near/NearChains"));
// Returns true if both chains are equal or aliases
const isSameChain = (chain1, chain2) => {
    return (chain1 === chain2 ||
        !![EvmChains_1.default, NearChains_1.default, BtcChains_1.default].find((chainSystem) => {
            return chainSystem.isSameChainFromString(chain1, chain2);
        }));
};
exports.isSameChain = isSameChain;
